// For production
export const global_url = "https://be.crm.petspot.in/petspot";

// For localhost
// export const global_url = "https://127.0.0.1:3001";